import React from 'react';
import './bootstrap';
import '@Assets/scss/layout/css/layout-light.css';
import 'primeflex/primeflex.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/mdc-light-indigo/theme.css';
import '@Assets/scss/app.scss';


import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

import '@fontsource/roboto';
import * as Sentry from '@sentry/react';
import { setupPendo, PendoAuthProps } from '@Utils/pendo';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'JMS';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx')),
  setup({ el, App, props }) {
    const { VITE_SENTRY_DSN_PUBLIC, VITE_PENDO_APP_ID, MODE } = import.meta.env;

    setupPendo(VITE_PENDO_APP_ID, props.initialPage.props.auth as PendoAuthProps | undefined);

    if (VITE_SENTRY_DSN_PUBLIC) {
      console.log('Sentry DSN found');
      Sentry.init({
        dsn: VITE_SENTRY_DSN_PUBLIC,
        integrations: [
          // Keep the Replay integration as before
          Sentry.replayIntegration(),

          // The following is all you need to enable canvas recording with Replay
          Sentry.replayCanvasIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions

        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'https://*.ionyx.io',
          'https://*.jmsapp.com.au',
        ],

        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: MODE.toLowerCase(),
      });
    }

    const root = createRoot(el);

    // eslint-disable-next-line react/jsx-props-no-spreading
    root.render(<App {...props} />);
  },
  progress: {
    color: '#4B5563',
  },
}).then(() => {
  setTimeout(() => {
    document.getElementById('splash-screen')?.remove();
  }, 500);
});
